import { render, staticRenderFns } from "./InDialogueAndMenu.vue?vue&type=template&id=61fb9d3e&"
import script from "./InDialogueAndMenu.vue?vue&type=script&lang=js&"
export * from "./InDialogueAndMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports